import { createReducer, on } from '@ngrx/store';
import { ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  AdmissionFeeEnboxChange,
  ApiKeyEnboxChange,
  BaseUrlEnboxChange,
  CloseEnboxEditIntegration,
  ConnectionTimeoutEnboxChange,
  CreditCostEnboxChange,
  EditEnboxIntegrationSystem,
  EmailNotifierChange,
  EnboxSubmitData,
  ExternalIdEnboxChange,
  LanguagesEnboxChange,
  LookBackDaysChange,
  NameEnboxChange,
  ReadTimeoutEnboxChange,
  SaveEnboxConfigurationFailed,
  SaveEnboxConfigurationSuccess,
  SegmentsRetentionDaysEnboxChange,
  StatusEnboxChange,
  ToggleCampaignReportingHelpTextStatus,
  ToggleCredentialsConfHelpTextStatus,
  ToggleEndpointConfHelpTextStatus,
  ToggleRootConfHelpTextStatus,
  UpdateEnboxConfigurationSuccess,
} from '../actions/enbox-configuration.actions';
import {
  CreateNewIntegration,
  FindAvailableLanguagesSuccess,
} from '../actions/integration-management-create-new.actions';
import { LanguageModel } from '../models/create-new-integration.model';

export interface EnboxConfigurationState {
  nameEnbox: string;
  isActiveEnbox: boolean;
  externalIdEnbox: string;
  selectedLanguageEnbox: LanguageModel[];
  admissionFeeEnbox: number | null;
  creditCostEnbox: number | null;
  segmentsRetentionDaysEnbox: number | null;
  baseUrlEnbox: string;
  readTimeoutEnbox: number | null;
  connectionTimeoutEnbox: number | null;
  apiKeyEnbox: string;
  emailNotifier: string;
  lookBackDays: number | null;
  languages: LanguageModel[];
  showUpdateBtn: boolean;
  disableName: boolean;
  rootConfigurationHelpTextStatus: boolean;
  credentialsConfigurationHelpTextStatus: boolean;
  campaignReportingHelpTextStatus: boolean;
  endpointConfigurationHelpTextStatus: boolean;
  selectedEnboxDataFromGrid: any;
  showCancelBtn: boolean;
  isSubmittedData: boolean;
}

const initialState: EnboxConfigurationState = {
  nameEnbox: '',
  isActiveEnbox: false,
  externalIdEnbox: '',
  selectedLanguageEnbox: [],
  admissionFeeEnbox: 0,
  creditCostEnbox: 0,
  segmentsRetentionDaysEnbox: 0,
  baseUrlEnbox: '',
  readTimeoutEnbox: 0,
  connectionTimeoutEnbox: 0,
  apiKeyEnbox: '',
  emailNotifier: '',
  lookBackDays: 15,
  languages: [],
  showUpdateBtn: false,
  disableName: false,
  rootConfigurationHelpTextStatus: false,
  credentialsConfigurationHelpTextStatus: false,
  campaignReportingHelpTextStatus: false,
  endpointConfigurationHelpTextStatus: false,
  selectedEnboxDataFromGrid: [],
  showCancelBtn: false,
  isSubmittedData: false,
};

export const EnboxConfigurationReducer = createReducer(
  initialState,
  on(NameEnboxChange, (state, { nameEnbox }) => ({
    ...state,
    nameEnbox,
  })),
  on(StatusEnboxChange, (state, { isActiveEnbox }) => ({
    ...state,
    isActiveEnbox,
  })),
  on(ExternalIdEnboxChange, (state, { externalIdEnbox }) => ({
    ...state,
    externalIdEnbox,
  })),
  on(LanguagesEnboxChange, (state, { selectedLanguageEnbox }) => ({
    ...state,
    selectedLanguageEnbox,
  })),
  on(AdmissionFeeEnboxChange, (state, { admissionFeeEnbox }) => ({
    ...state,
    admissionFeeEnbox,
  })),
  on(CreditCostEnboxChange, (state, { creditCostEnbox }) => ({
    ...state,
    creditCostEnbox,
  })),
  on(SegmentsRetentionDaysEnboxChange, (state, { segmentsRetentionDaysEnbox }) => ({
    ...state,
    segmentsRetentionDaysEnbox,
  })),
  on(BaseUrlEnboxChange, (state, { baseUrlEnbox }) => ({
    ...state,
    baseUrlEnbox,
  })),
  on(ReadTimeoutEnboxChange, (state, { readTimeoutEnbox }) => ({
    ...state,
    readTimeoutEnbox,
  })),
  on(ConnectionTimeoutEnboxChange, (state, { connectionTimeoutEnbox }) => ({
    ...state,
    connectionTimeoutEnbox,
  })),
  on(ApiKeyEnboxChange, (state, { apiKeyEnbox }) => ({
    ...state,
    apiKeyEnbox,
  })),
  on(EmailNotifierChange, (state, { emailNotifier }) => ({
    ...state,
    emailNotifier,
  })),
  on(LookBackDaysChange, (state, { lookBackDays }) => ({
    ...state,
    lookBackDays,
  })),
  on(FindAvailableLanguagesSuccess, (state, { res }) => {
    return {
      ...state,
      languages: res,
    };
  }),
  on(SaveEnboxConfigurationSuccess, (state, { res }) => ({
    ...state,
    showUpdateBtn: true,
    disableName: true,
    nameEnbox: res.payload.data.integrationConfig.integrationDisplayName,
    isActiveEnbox: res.payload.data.deleted,
    externalIdEnbox: res.payload.data.integrationConfig.externalListID,
    selectedLanguageEnbox: res.payload.data.integrationConfig.supportedSalutionLanguages,
    admissionFeeEnbox: res.payload.data.integrationConfig.admitionFee,
    creditCostEnbox: res.payload.data.integrationConfig.creditCost,
    segmentsRetentionDaysEnbox: res.payload.data.integrationConfig.segmentRetentionDays,
    baseUrlEnbox: res.payload.data.endpointConfiguration.endpointConfig.baseURL,
    readTimeoutEnbox: res.payload.data.endpointConfiguration.endpointConfig.readTimeOut,
    connectionTimeoutEnbox: res.payload.data.endpointConfiguration.endpointConfig.connectionTimeOut,
    apiKeyEnbox: res.payload.data.endpointConfiguration.credentialConfig.key,
    languages: state.languages,
    rootConfigurationHelpTextStatus: false,
    credentialsConfigurationHelpTextStatus: false,
    endpointConfigurationHelpTextStatus: false,
    isSubmittedData: false,
  })),
  on(SaveEnboxConfigurationFailed, (state) => ({
    ...state,
    showUpdateBtn: false,
    disableName: false,
  })),
  on(EditEnboxIntegrationSystem, (state, { enboxData }) => ({
    ...state,
    nameEnbox: enboxData.integrationConfig.integrationDisplayName,
    isActiveEnbox: enboxData.deleted,
    externalIdEnbox: enboxData.integrationConfig.externalListID,
    selectedLanguageEnbox: enboxData.integrationConfig.supportedSalutionLanguages,
    admissionFeeEnbox: enboxData.integrationConfig.admitionFee,
    creditCostEnbox: enboxData.integrationConfig.creditCost,
    segmentsRetentionDaysEnbox: enboxData.integrationConfig.segmentRetentionDays,
    baseUrlEnbox: enboxData.endpointConfiguration.endpointConfig.baseURL,
    readTimeoutEnbox: enboxData.endpointConfiguration.endpointConfig.readTimeOut,
    connectionTimeoutEnbox: enboxData.endpointConfiguration.endpointConfig.connectionTimeOut,
    apiKeyEnbox: enboxData.endpointConfiguration.credentialConfig.key,
    emailNotifier: enboxData.integrationConfig.executionNotificationReceiver,
    lookBackDays: enboxData.integrationConfig.daysLookBack,
    languages: state.languages,
    showUpdateBtn: true,
    disableName: true,
    showCancelBtn: true,
    isSubmittedData: false,
  })),
  on(CreateNewIntegration, (state) => ({
    ...state,
    nameEnbox: '',
    isActiveEnbox: false,
    externalIdEnbox: '',
    selectedLanguageEnbox: [],
    admissionFeeEnbox: 0,
    creditCostEnbox: 0,
    segmentsRetentionDaysEnbox: 0,
    baseUrlEnbox: '',
    readTimeoutEnbox: 0,
    connectionTimeoutEnbox: 0,
    apiKeyEnbox: '',
    showUpdateBtn: false,
    lookBackDays: 15,
    languages: state.languages,
    disableName: false,
    rootConfigurationHelpTextStatus: false,
    credentialsConfigurationHelpTextStatus: false,
    endpointConfigurationHelpTextStatus: false,
    showCancelBtn: false,
    isSubmittedData: false,
  })),
  on(UpdateEnboxConfigurationSuccess, (state, { res }) => ({
    ...state,
    showUpdateBtn: true,
    disableName: true,
    nameEnbox: res.payload.data.integrationConfig.integrationDisplayName,
    isActiveEnbox: res.payload.data.deleted,
    externalIdEnbox: res.payload.data.integrationConfig.externalListID,
    selectedLanguageEnbox: res.payload.data.integrationConfig.supportedSalutionLanguages,
    admissionFeeEnbox: res.payload.data.integrationConfig.admitionFee,
    creditCostEnbox: res.payload.data.integrationConfig.creditCost,
    segmentsRetentionDaysEnbox: res.payload.data.integrationConfig.segmentRetentionDays,
    baseUrlEnbox: res.payload.data.endpointConfiguration.endpointConfig.baseURL,
    readTimeoutEnbox: res.payload.data.endpointConfiguration.endpointConfig.readTimeOut,
    connectionTimeoutEnbox: res.payload.data.endpointConfiguration.endpointConfig.connectionTimeOut,
    apiKeyEnbox: res.payload.data.endpointConfiguration.credentialConfig.key,
    lookBackDays: res.payload.data.integrationConfig.daysLookBack,
    languages: state.languages,
  })),
  on(ToggleRootConfHelpTextStatus, (state) => ({
    ...state,
    rootConfigurationHelpTextStatus: !state.rootConfigurationHelpTextStatus,
  })),
  on(ToggleCredentialsConfHelpTextStatus, (state) => ({
    ...state,
    credentialsConfigurationHelpTextStatus: !state.credentialsConfigurationHelpTextStatus,
  })),
  on(ToggleCampaignReportingHelpTextStatus, (state) => ({
    ...state,
    campaignReportingHelpTextStatus: !state.campaignReportingHelpTextStatus,
  })),
  on(ToggleEndpointConfHelpTextStatus, (state) => ({
    ...state,
    endpointConfigurationHelpTextStatus: !state.endpointConfigurationHelpTextStatus,
  })),
  on(CloseEnboxEditIntegration, () => initialState),
  on(EnboxSubmitData, (state) => ({
    ...state,
    isSubmittedData: true,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
